import {React, useEffect, useState, useRef} from "react";
import Popup from "reactjs-popup";
import {Link} from "react-router-dom";
import LogoImage from './LogoImage';

const Error = (props) => (


    <Popup className={`error ${props.isErrorM ? '' : 'hide'}`} open={props.isErrorM} arrow={false} modal
           nested>
        {close => (<>
          <Link to='/' className="logo">
            <LogoImage className="header-logo-img" imageStyle={'big'}/>
          </Link>
            <p>Error Submitting Order: {props.Message}</p>
            <p>Please contact us at <a href={'mailto:' + process.env.REACT_APP_EMAIL}>{process.env.REACT_APP_EMAIL}</a></p>
            <div className='close_modal' onClick={() => {
                close();
            }}>&times;</div>
        </>)}
    </Popup>

);

export default Error;
